// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file ping/ping_response.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { BooleanResponse } from '../common/common_responses_pb';
import { file_common_common_responses } from '../common/common_responses_pb';

/**
 * Describes the file ping/ping_response.proto.
 */
export const file_ping_ping_response: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChhwaW5nL3BpbmdfcmVzcG9uc2UucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0IlAKDFBvbmdSZXNwb25zZRI4CgdzdWNjZXNzGAEgASgLMiUuY29tLmdlbS5iZmYuY29udHJhY3QuQm9vbGVhblJlc3BvbnNlSABCBgoEdHlwZUIYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM',
    [file_common_common_responses]
  );

/**
 * @generated from message com.gem.bff.contract.PongResponse
 */
export type PongResponse = Message<'com.gem.bff.contract.PongResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.PongResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.PongResponse.
 * Use `create(PongResponseSchema)` to create a new message.
 */
export const PongResponseSchema: GenMessage<PongResponse> =
  /*@__PURE__*/
  messageDesc(file_ping_ping_response, 0);
